import React, { useState, useEffect } from "react";
import { setSimulateurObject } from "../../../actions/simulateur.action";
import { useDispatch } from "react-redux";
import { styles } from "../../../stylesheets/simulateurs.css";
import "../../../stylesheets/simulateursBis.css";
import TextSimulateurTitle from "../../../components/texts/text.simulateurTitle";
import TextfieldNumber from "../../../components/textfields/textfield.number";
import SelectDepartement from "../../../components/selects/select.departement";
import TextfieldRemarques from "../../../components/textfields/textfiel.remarques";
import DeboursQuestion from "../../../components/questions/DeboursQuestion";
import ConventionHonoraires from "../../../components/questions/ConventionHonoraires";
import Simulateur84 from "../simulateur.A1.12/simulateur.A1.12";
import ButtonYesno from "../../../components/buttons/button.yesno.js";
import BadgeNouveau from "../../../components/texts/BadgeNouveau.js";
import CautionSansGarantieHypo from "../../../components/questions/CautionSansGarantieHypo.js";

// simulateur Id 24

function Simulateur_A1_24bis(props) {
  const dispatch = useDispatch();

  let currUser = JSON.parse(localStorage.getItem("user"));
  let currUserDep = 0;
  if (currUser.societe_zip.startsWith("97")) {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 3);
    currUserDep = parseInt(trimedZip);
  } else {
    let trimedZip;
    trimedZip = currUser.societe_zip.slice(0, 2);
    currUserDep = parseInt(trimedZip);
  }

  const [departement, setDepartement] = useState(0);
  const [montant_licitee, setMontant] = useState(0);
  const [montantDeboursAdditionnels, setMontantDeboursAdditionnels] = useState(0);
  const [deboursAdditionnels, setDeboursAdditionnels] = useState(0);
  const [pretHypo, setPretHypo] = useState(0);
  const [cautionSansGarantieHypo, setCautionSansGarantieHypo] = useState(0);
  const [simu114, setSimu114] = useState(null);
  const [simu84, setSimu84] = useState(null);
  const [dependances, setDependancesState] = useState([]);

  const handleChange = async (setter, value, key) => {
    if (setter === setDepartement) {
      setDepartement(parseInt(value));
    } else setter(value);
    setInRedux(setter, value, key);
  };

  const handleChangeRemarque = async (value) => {
    localStorage.setItem("remarque", value);
  };

  useEffect(() => {
    if (simu84 !== undefined && simu84 !== null) setDependances(simu84);
  }, [simu84]);

  useEffect(() => {
    if (simu114 !== undefined && simu114 !== null) setDependances(simu114);
  }, [simu114]);

  function setDependances(simu) {
    setInRedux("dependance", simu);
  }

  function setInRedux(setter, value, key) {
    if (props.isParent) {
      let object = {
        simulateurid: props.simulateur.id,
        departementid: parseInt(departement),
        inputs: {
          montant_licitee: parseInt(montant_licitee),
          montant_deb_add: parseInt(montantDeboursAdditionnels),
          debours_additionnels: parseInt(deboursAdditionnels),
          pret_hypo: parseInt(pretHypo),
          convention_honoraires : parseInt(props.conventionHonoraires),
        },
        dependances: dependances,
        pdfInputs: {
          nombre_convention_honoraires : parseInt(props.nombreConventionHonoraires),
          object_convention_honoraires : props.objectConventionHonoraires,
          montant_convention_honoraires : parseInt(props.montantConventionHonoraires),
          nom_signataire_convention_honoraires : props.nomSignataireConventionHonoraires,
          adresse_signataire_convention_honoraires : props.adresseSignataireConventionHonoraires,
        },
      };
      //For values coming from components
      if (key) {
        if (key === "debours_additionnels") {
          if (value === 0) {
            setMontantDeboursAdditionnels(0)
            Object.assign(object["inputs"], { montant_deb_add: parseInt(0) });
          }
          Object.assign(object["inputs"], { debours_additionnels: parseInt(value) });
        }
        if (key === "montant_deb_add") {
          Object.assign(object["inputs"], { montant_deb_add: parseInt(value) });
        }
      }
      //For internal settings
      if (setter === setDepartement) {
        object.departementid = parseInt(value);
      }

      if (setter === setPretHypo && value === 0) {
        setSimu84(null);
        setDependancesState([]);
        object.dependances = [];
      }

      if (setter === setCautionSansGarantieHypo && value === 1) {
        setPretHypo(0);
        setSimu84(null);
        setDependancesState([]);
        object.dependances = [];
      }

      if (setter === setCautionSansGarantieHypo && value === 0) {
        setSimu114(null);
        setDependancesState([]);
        object.dependances = [];
      }

      if (setter === "dependance") {
        if (dependances.length > 0) object.dependances = dependances;

        if (value !== undefined) {
          let validator = false;

          for (let i = 0; i < object["dependances"].length; i++) {
            if (object["dependances"][i]?.simulateurid === value.simulateurid) {
              object.dependances[i] = value;
              validator = true;
            }
          }

          if (validator === false) {
            object.dependances.push(value);
          }

          setDependancesState(object.dependances);
        }
      }

      if (setter === setMontant) {
        Object.assign(object["inputs"], { montant_licitee: parseInt(value) });
      }

      if (setter === props.setConventionHonoraires) {
        if(value === 0){
          props.setNombreConventionHonoraires(1);
          props.setObjectConventionHonoraires(null);
          props.setMontantConventionHonoraires(null);
          props.setNomSignataireConventionHonoraires(null);
          props.setAdresseSignataireConventionHonoraires(null);
          Object.assign(
            object["inputs"], { convention_honoraires : parseInt(value) },
            object["pdfInputs"], {
              nombre_convention_honoraires : null,
              object_convention_honoraires : null,
              montant_convention_honoraires : null,
              nom_signataire_convention_honoraires : null,
              adresse_signataire_convention_honoraires : null
            },
          );
        } else {
          Object.assign(object["inputs"], { convention_honoraires : parseInt(value) });
        }
      }

      if (setter === props.setNombreConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nombre_convention_honoraires : parseInt(value) });
      }

      if (setter === props.setObjectConventionHonoraires) {
        Object.assign(object["pdfInputs"], { object_convention_honoraires : value });
      }

      if (setter === props.setMontantConventionHonoraires) {
        Object.assign(object["pdfInputs"], { montant_convention_honoraires : parseInt(value)});
      }

      if (setter === props.setNomSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { nom_signataire_convention_honoraires : value });
      }

      if (setter === props.setAdresseSignataireConventionHonoraires) {
        Object.assign(object["pdfInputs"], { adresse_signataire_convention_honoraires : value });
      }

      dispatch(setSimulateurObject(object));
    } else {
      // process child simu
    }
  }

  return (
    <div style={styles.container}>
      <div className="cardSimulateur">
        <TextSimulateurTitle title={props.simulateur.name} currentSimuId={props.simulateur.id} />

        <TextfieldRemarques handleChange={handleChangeRemarque} />

        <p style={styles.cardSubTitle}>
          Licitation acte tarifé Tableau 5, n° 48 (Art A444-87 C.Com).
          <br /> Prêts aux particuliers acte tarifé Tableau 5, n° 137 (Art A444-143 C.Com), Cautionnements acte tarifé Tableau 5, n° 111 (Art A444-127 C.Com). 
          Sauf dispositions contraires en date du 1er janvier 2021, l’article 750 II du CGI reste inchangé et n’a pas été modifié suite à la réforme du droit de 
          partage - Art 108 V issue de la Loi de finances 2020 N°2019-1474.
        </p>

        {props?.isParent === true && props.departements !== "" ? (
          <>
            <div className="cardRow">
              <div style={styles.cardElemVerticalyCenter}>Département :</div>

              <SelectDepartement
                items={props.departements}
                nameField={"name"}
                defaultValue={currUserDep}
                optionValue={"id"}
                handleChange={handleChange}
                setter={setDepartement}
              />
            </div>
            <div style={styles.cardRowSpecialMessage}>
              La taxe départementale utilisée pour vos calculs est bien celle qui a été votée dans votre département. Attention de bien penser à indiquer le bon département lorsque vous effectuez une vente sur un département qui n’est pas le votre.
            </div>
          </>
        ) : (
          <></>
        )}

        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>Quel est le montant de la part licitée ?</div>
          <TextfieldNumber
            handleChange={handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={setMontant}
          />
        </div>
        <CautionSansGarantieHypo
          cautionSansGarantieHypo={cautionSansGarantieHypo}
          setCautionSansGarantieHypo={setCautionSansGarantieHypo}
          setSimu114={setSimu114}
          simulateur={props.simulateur}
          departementId={departement}
          handleChange={handleChange}
        />

        <div
          className="cardRow"
          style={parseInt(cautionSansGarantieHypo) === 1 ? { opacity: 0.5, pointerEvents: "none" } : {}}
        >
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il un prêt hypothécaire ?
            <BadgeNouveau cliquable={false}/>
          </div>
          <div>
            <ButtonYesno handleChange={handleChange} setter={setPretHypo} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>

        {parseInt(cautionSansGarantieHypo) !== 1 && parseInt(pretHypo) === 1 ? (
          <>
            <Simulateur84
              simulateur={props.simulateur}
              isParent={false}
              departementId={departement}
              dependances={setSimu84}
            />
          </>
        ) : (
          <></>
        )}

        <DeboursQuestion
            handleChange={handleChange}
            deboursAdditionnels={deboursAdditionnels}
            setDeboursAdditionnels={setDeboursAdditionnels}
            setMontantDeboursAdditionnels={setMontantDeboursAdditionnels}
        />

        <ConventionHonoraires
          handleChange={handleChange}
          conventionHonoraires={props.conventionHonoraires}
          setConventionHonoraires={props.setConventionHonoraires}
          nombreConventionHonoraires={props.nombreConventionHonoraires}
          setNombreConventionHonoraires={props.setNombreConventionHonoraires}
          objectConventionHonoraires={props.objectConventionHonoraires}
          setObjectConventionHonoraires={props.setObjectConventionHonoraires}
          montantConventionHonoraires={props.montantConventionHonoraires}
          setMontantConventionHonoraires={props.setMontantConventionHonoraires}
          nomSignataireConventionHonoraires={props.nomSignataireConventionHonoraires}
          setNomSignataireConventionHonoraires={props.setNomSignataireConventionHonoraires}
          adresseSignataireConventionHonoraires={props.adresseSignataireConventionHonoraires}
          setAdresseSignataireConventionHonoraires={props.setAdresseSignataireConventionHonoraires}
        />
      </div>
    </div>
  );
}

export default Simulateur_A1_24bis;
